import { createAction } from "redux-act";

export const changeTheme = createAction("Change theme");